module.exports = __webpack_public_path__ + "static/media/AU.2b2d5b20.png";